<template>
  <div>
    <div class="dont-print">
      <div>
        View Rows by: 
        <button :class="store.selectedKey === 'Day' ? 'selected' : ''" @click="store.selectedKey = 'Day'">Day</button>
        <button :class="store.selectedKey === 'Shift' ? 'selected' : ''" @click="store.selectedKey = 'Shift'">Shift</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ReconcilliationViewSelector',
  data(){
    return {
    }
  },
  inject: ['page'],
  props:[
    'storeName',
  ],
  computed:{
    store(){return this.page.$refs[this.storeName]},
  },
  mounted(){
  },
  methods:{
  }
  

}
</script>

<style scoped>
.selected{
  /* opacity: 0.6; */
  background-color: darkgray;
}
</style>